import { Button, Div } from '@driftt/tide-core'
import * as R from 'ramda'
import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { withRouter } from 'react-router-dom'

import Dropdown from './Drowndown'

import './style.css'

const XPlaybookErrorsNotifier = ({ location, isPreviewState }) => {
  const { playbook = {}, experiment } = useSelector(
    R.path(['__PLAYBOOK_EDITOR', 'playbookValidation'])
  )
  const [isDropdownOpen, setIsDropdownOpen] = useState(false)

  const editorErrors = location.pathname.endsWith('experiment')
    ? experiment
    : playbook

  const handleClick = () => setIsDropdownOpen(true)
  const handleClickOutside = () => setIsDropdownOpen(false)

  if (isPreviewState || R.isEmpty(editorErrors)) return null

  return (
    <Div className="playbook-errors-notifier">
      <Button
        className="playbook-errors-notifier--trigger"
        icon="warning-triangle"
        onClick={handleClick}
        type="danger"
      />
      {isDropdownOpen && (
        <Dropdown
          onClickOutside={handleClickOutside}
          editorErrors={editorErrors}
        />
      )}
    </Div>
  )
}

export default withRouter(XPlaybookErrorsNotifier)
